import React, { useState } from "react";
import "../../assets/styles/components/_login.scss";
import logo from "../../assets/images/brand/Tensolite-Isologotipo-blanco.png";
import useForm from "../../hooks/useForm";
import { toast } from "react-hot-toast";
import useCliente from "../../hooks/useCliente";
import { useLocation } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const NewPassword = () => {
  const { values, handleInputChange } = useForm({
    newFirstPassword: "",
    newSecondPassword: "",
  });

  const [errorNotMatchPassword, setErrorNotMatchPassword] = useState(false);

  const [inputError, setInputError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showPasswordFirst, setShowPasswordFirst] = useState(false);
  const [showPasswordSecond, setShowPasswordSecond] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const { changeOldPassword } = useCliente();

  const MostrarMensajeError = (event, message) => {
    const toastMessage = message ? message : "Las contraseñas no coinciden";
    toast.error(toastMessage, {
      duration: 1500,
    });
    event.preventDefault();
  };

  const VerificarCampos = (event) => {
    const userEmail = queryParams.get("userEmail");
    const userRole = queryParams.get("userRole");
    event.preventDefault();

    if (
      values.newFirstPassword.length < 6 ||
      !/[A-Z]/.test(values.newFirstPassword) ||
      !/[0-9]/.test(values.newFirstPassword)
    ) {
      setPasswordError(true);
      MostrarMensajeError(
        event,
        "La contraseña debe tener al menos 6 caracteres, una letra mayúscula y un número. Ademas la contraseña debe tener entre 6 y 12"
      );
      return;
    }

    if (values.newFirstPassword === values.newSecondPassword) {
      const userInfo = {
        newPassword: values.newFirstPassword,
        email: userEmail,
        role: userRole
      };
      changeOldPassword(userInfo);
    } else {
      setErrorNotMatchPassword(true);
      MostrarMensajeError(event, "Las contraseñas no coinciden.");
    }

    if (values.newFirstPassword === "" || values.newSecondPassword === "") {
      setInputError(true);
    }
  };

  const toggleShowPasswordFirst = () => {
    setShowPasswordFirst(!showPasswordFirst);
  };
  const toggleShowPasswordSecond = () => {
    setShowPasswordSecond(!showPasswordSecond);
  };

  return (
    <>
      <form className="container login__card-form" onSubmit={VerificarCampos}>
        <div className="logo-login">
          <img src={logo} alt="Logo Tensolite" className="logo" />
        </div>
        <div className="flex-col">
          <label className="super_label_recover">
            Ingrese su nueva contraseña
          </label>
          <div className="flex-row gap-x-2 login__card-form__first_password">
            <input
              maxLength={12}
              type={showPasswordFirst ? "text" : "password"}
              id="newFirstPassword"
              name="newFirstPassword"
              className={`lf--input new-first-input-password ${
                errorNotMatchPassword || inputError || passwordError
                  ? "input-error"
                  : ""
              } `}
              placeholder="Nueva contraseña"
              value={values.newFirstPassword}
              onChange={handleInputChange}
            />
            <button
              type="button"
              className="first-password-toggle-button"
              onClick={toggleShowPasswordFirst}
            >
              {showPasswordFirst ? (
                <VisibilityOffIcon
                  sx={{
                    color: "white",
                  }}
                />
              ) : (
                <VisibilityIcon
                  sx={{
                    color: "white",
                  }}
                />
              )}
            </button>
          </div>
        </div>
        <div className="flex-row login__card-form__second_password gap-x-2 items-center ">
          <input
            maxLength={12}
            type={showPasswordSecond ? "text" : "password"}
            id="newSecondPassword"
            name="newSecondPassword"
            className={`lf--input new-second-input-password ${
              errorNotMatchPassword || inputError || passwordError
                ? "input-error"
                : ""
            } `}
            placeholder="Ingrese su Nueva Contraseña"
            value={values.newSecondPassword}
            onChange={handleInputChange}
          />
          <button
            type="button"
            className="second-password-toggle-button"
            onClick={toggleShowPasswordSecond}
          >
            {showPasswordSecond ? (
              <VisibilityOffIcon
                sx={{
                  color: "white",
                }}
              />
            ) : (
              <VisibilityIcon
                sx={{
                  color: "white",
                }}
              />
            )}
          </button>
        </div>
        <input
          type="submit"
          className="button--submit"
          value="Cambiar contraseña"
        />
      </form>
    </>
  );
};

export default NewPassword;
